import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import styles from './skiplink.scss.js';
import '@cigna/cigna_csg_gsg_cipublic-button/cipublic-button.js';
/**
 * @element cipublic-skiplink
 */
export class Skiplink extends CipublicElement {
    constructor() {
        super(...arguments);
        this.iscipublic = false;
    }
    static get styles() {
        return [styles];
    }
    handleClick(e) {
        var _a, _b;
        e.preventDefault();
        const target = this.target;
        let element = document.querySelector(`${target}`);
        const tabIndex = '-1';
        element === null || element === void 0 ? void 0 : element.scrollIntoView({ behavior: 'smooth' });
        if (this.iscipublic) {
            if (target === '#main') {
                const allFirstElements = Array.from(document.querySelectorAll('cipublic-breadcrumb, ciapp-personalization-wrapper, cipublic-alert, cipublic-hero'));
                const getBreadcrumb = allFirstElements.findIndex((element) => element.tagName.includes('BREADCRUMB'));
                const firstElementAfterBreadcrumbs = getBreadcrumb > -1 ? getBreadcrumb + 1 : 0;
                element = allFirstElements[firstElementAfterBreadcrumbs];
            }
            else if (target === '#cipublic-header') {
                element = (_b = (_a = document.querySelector('cipublic-header')) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('[id="cipublic-header"]');
            }
        }
        element === null || element === void 0 ? void 0 : element.setAttribute('tabindex', tabIndex);
        element === null || element === void 0 ? void 0 : element.classList.add('no-focus-visible-outline');
        element.focus();
    }
    render() {
        return html `<div class="skip-link"><cipublic-button href="${ifDefined(this.target)}" type="button" variant="skiplink" @click="${this.handleClick}"><slot></slot></cipublic-button></div>`;
    }
}
__decorate([
    property({ reflect: true })
], Skiplink.prototype, "target", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], Skiplink.prototype, "iscipublic", void 0);
//# sourceMappingURL=skiplink.js.map